import React, { useState } from "react";
import {
  Grid,
  Typography,
  Box,
  TextField,
  FormControl,
  FormHelperText,
  Button,
  Grid2,
  Paper,InputBase
} from "@mui/material";
import { Description, Email, Phone } from "@mui/icons-material";
import { FileUploader } from "react-drag-drop-files";
import pic from "../../ui-utils/latestPics/contactUslogo.svg"
import call from "../../ui-utils/latestPics/call.svg"
import msg from "../../ui-utils/latestPics/msg.svg"
import Secure from "../../Assets/Images/secure.svg";
import { backendHosts,apiUrl } from "../../ui-utils/apiConfig";

import './SupportWebView.css'
import axios from "axios";


import en from "../../i18n/English/Support/home.json";
import hi from "../../i18n/Hindi/Support/home.json";
import kn from "../../i18n/Kannada/Support/home.json";
import ma from "../../i18n/Marathi/Support/home.json";
import gu from "../../i18n/Gujarati/Support/home.json";
import { useLanguage } from "../../Context/LangContext";
import DocumentMeta from 'react-document-meta'

const meta = {
  title: 'Support | 24/7 Help for Trading & Demat Accounts | TradeBoss',
  description: "Need help? Contact TradeBoss Support for expert guidance on trading, demat accounts, and investments. Fast, reliable, and always available.",
  canonical: 'https://tradeboss.co/support/contact',
  meta: {
    charset: 'utf-8',
    name: {
      keywords: 'TradeBoss support, trading support India, demat account help, customer service trading platform, contact tradeboss, helpdesk online trading, trading platform support'
    }
  }
}
const SupportWebView = () => {
    const [form, setForm] = useState({
    fname: "",
    phoneno: "",
    emailid: "",
    description: "",
    file: null,
    filename: "",

  });
  const [errtype, setErrType] = useState(0);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg]=useState("")
  const handleChange = (file) => {
    setForm((prev) => ({ ...prev, file, filename: file.name }));
  };

  const { language } = useLanguage();
  const translations = { en, hi, kn,gu,ma };
  const t = translations[language];

  const handleInputChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    setErrType(0);
    setSuccessMsg("")
  };

  const Submitquery = async() => {

    if (!form.fname.trim()) {
      setErrType(1);
      setErrorMsg("Name is required");
      return;
    } else if (!/^[A-Za-z\s]+$/.test(form.fname)) {
      setErrType(1);
      setErrorMsg("Name should contain only alphabets");
      return;
    }


    if (!form.phoneno.trim()) {
      setErrType(2);
      setErrorMsg("Contact number is required");
      return;
    } else if (!/^\d{10}$/.test(form.phoneno)) {
      setErrType(2);
      setErrorMsg("Enter a valid 10-digit contact number");
      return;
    }


    if (!form.emailid.trim()) {
      setErrType(4);
      setErrorMsg("Email is required");
      return;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(form.emailid)) {
      setErrType(4);
      setErrorMsg("Enter a valid email address");
      return;
    }


    if (!form.description || !form.description.trim()) {
      setErrType(3);
      setErrorMsg("Description is required");
      return;
    }

    setErrType(0);
    setErrorMsg("");

    const payload = {
      data: {
        type: "Support",
        name: form.fname,
        email: form.emailid,
        mobile: form.phoneno,
        description: form.description,
        base64:form.base64 || ""
      },
    };

    console.log("Form submitted successfully", payload);

    try{
         const response=await axios.post(`${backendHosts.ADMIN}${apiUrl.ticket}`,payload)

         if(response.data?.data?.status ==200){
          setForm({
            fname: "",
            emailid: "",
            phoneno: "",
            description: "",
            base64:""
          })
           setSuccessMsg("Your query has been submitted successfully!")
         }

    }catch(error){
      setSuccessMsg("")
       console.log(error)
    }

    // Add actual submission logic here
  };


 const handlePicFile = async (file) => {
  if (!file) {
    setErrType(5);
    setErrorMsg("No file selected.");
    setSuccessMsg("")
    return;
  }

  const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
  if (!validImageTypes.includes(file.type)) {
    setErrType(5);
    setErrorMsg("Invalid file type. Please upload an image (JPEG, PNG, JPG)");
    setSuccessMsg("")
    setForm((prev) => ({ ...prev, base64: "", filename: "" }));
    return;
  }

  const maxSize = 5 * 1024 * 1024; // 5 MB
  if (file.size > maxSize) {
    setErrType(5);
    setErrorMsg("File size exceeds the 5MB limit.");
    setSuccessMsg("")
    setForm((prev) => ({ ...prev, base64: "", filename: "" }));
    return;
  }

  const fileReader = new FileReader();
  fileReader.onload = async () => {
    try {
      const base64Image = fileReader.result.split(",")[1];
      const data = `data:image/jpeg;base64,${base64Image}`;

      setForm((prev) => ({
        ...prev,
        base64: data,
        filename: file.name,
        file: file,
      }));

      setErrorMsg("");
      setSuccessMsg("")
    } catch (error) {
      console.error("Error converting image to Base64:", error);
    }
  };

  fileReader.readAsDataURL(file);
};



  return (
    <Box className="supbxcntr" sx={{ px: { xs: 2, sm: 4, md: 6, lg: 8 }, width: '100%'}}>
      <DocumentMeta {...meta} />
  <Grid container spacing={4}>
    {/* Left Content */}
        <Grid item xs={12} md={7}  className="leftCard">

          <div className="headingContainer">
            <div className="gradientBackground"></div>
            <Typography className="heading" style={{ fontWeight: 600 }}>
              {t.heading}
            </Typography>
          </div>
      <Grid2 className="card">
            <h1 className="triv_txth" sx={{ ml: 0, mr: 4, mb: 1, mt: 0 }}>
              {t.tradeboss}
            </h1>
            {/* <img src={pic} className="pic"/> */}
      </Grid2>


      {/* <Box sx={{ mb: 2, pt:2}}>
        <img
          src={TradeBossLogo}
          alt="Trade Boss Logo"
            className="logo"


        />
      </Box> */}

      <Grid >
        {/* <Grid item xs={12} sm={8}>


          <Typography className="triv_txt" >
                (TRIVENI MANAGEMENT CONSULTANCY SERVICES LTD)<br/>
                <span className="span">Registered office :</span> A-2, Bandra Liberty Co-Op Hsg. Soc. 98, Hill Road,<br />
                Bandra (West), Mumbai, Maharastra - 400050<br/>
                <Grid sx={{ display: "flex", gap: "50px" }}>
                  <Box sx={{ display: "flex", alignItems: "center", paddingTop: "5px" }}>
                    <a href="tel: +91 74003 62816 ">
                      <Phone sx={{ color: "#000", fontSize:20 }} />
                    </a>
                    <a href="tel: +91 74003 62816" style={{ textDecoration: "none" }}>
                      <Typography sx={{ ml: 2 }} className="sup_cnt_txt">
                        +91 74003 62816
                      </Typography>
                    </a>

                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center", paddingTop: "10px" }}>
                    <a href="mailto:info@tradeboss.co">
                      <Email sx={{ color: "#000", fontSize: 25 }} />
                    </a>
                    <a href="mailto:info@tradeboss.co" style={{ textDecoration: "none" }}>
                      <Typography sx={{ ml: 2 }} className="sup_cnt_txt">
                        info@tradeboss.co
                      </Typography>
                    </a>
                  </Box>
                </Grid>
                <span className="span" >Corporate Office :</span>  14/2, Western India House, Sir P.M. Road,<br />
                Fort, Mumbai 400 001.<br/>

                <Grid sx={{display:"flex",gap:"50px"}}>
                  <Box sx={{ display: "flex", alignItems: "center", paddingTop: "5px" }}>
                    <a href="tel:+91 77384 60922 ">
                      <Phone sx={{ color: "#000", fontSize: 20 }} />
                    </a>
                    <a href="tel:+91 77384 60922 " style={{ textDecoration: "none" }}>
                      <Typography sx={{ ml: 2 }} className="sup_cnt_txt">
                        +91 77384 60922
                      </Typography>
                    </a>

                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center",paddingTop:"10px" }}>
                    <a href="mailto:info@tradeboss.co">
                      <Email sx={{ color: "#000", fontSize: 25 }} />
                    </a>
                    <a href="mailto:info@tradeboss.co" style={{ textDecoration: "none" }}>
                      <Typography sx={{ ml: 2 }} className="sup_cnt_txt">
                        info@tradeboss.co
                      </Typography>
                    </a>
                  </Box>
                </Grid>

          </Typography>
        </Grid> */}

            <Grid item xs={12} sm={8}>


              <Typography className="triv_txt">
                {t.title}<br />
                <span className="span" style={{ fontWeight: 600 }}>{t.regOff}</span>{t.regAdd}<br />
               {t.regAdd1}
              </Typography>

              <Grid className="contactBox">
                <Box sx={{ display: "flex", alignItems: "center", paddingTop: "5px",
                  '@media (max-height:620px)': {
                    paddingTop: "0px"
                  }
                 }}>
                  <a href="tel:+91 74003 62816" aria-label="Call">
                    <img src={call} alt="icon" className="icons" />
                  </a>
                  <a href="tel:+91 74003 62816" aria-label="Call" style={{ textDecoration: "none" }}>
                    <Typography  className="sup_cnt_txt">
                      +91 74003 62816
                    </Typography>
                  </a>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", paddingTop: "10px",
                  '@media (max-height:620px)': {
                    paddingTop: "5px"
                  }
                 }}>
                  <a href="mailto:info@tradeboss.co" aria-label="Email customer care">
                    <img src={msg} alt="icon" className="icons" />
                    {/* <Email sx={{ color: "#000", fontSize: 25 }} /> */}
                  </a>
                  <a href="mailto:info@tradeboss.co" aria-label="Email customer care"  style={{ textDecoration: "none" }}>
                    <Typography className="sup_cnt_txt" sx={{paddingBottom:"3px"}}>
                      info@tradeboss.co
                    </Typography>
                  </a>
                </Box>
              </Grid>

              <Typography className="triv_txt" sx={{
                mt: 2, '@media (max-height:620px)': {
                  mt: 1
                } }}>
                <span className="span" style={{fontWeight:"600"}}>{t.copOff}</span> {t.copAdd}<br />
                {t.copAdd1}
              </Typography>

              <Grid className="contactBox">
                <Box sx={{ display: "flex", alignItems: "center", paddingTop: "5px",
                  '@media (max-height:620px)': {
                    paddingTop: "0px"
                  }
                 }}>
                  <a href="tel:+91 77384 60922" aria-label="Call">
                    <img src={call} alt="icon" className="icons" />
                  </a>
                  <a href="tel:+91 77384 60922" aria-label="Call"  style={{ textDecoration: "none" }}>
                    <Typography className="sup_cnt_txt">
                      +91 77384 60922
                    </Typography>
                  </a>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", paddingTop: "10px",

                 }}>
                  <a href="mailto:info@tradeboss.co" aria-label="Email customer care">
                    <img src={msg} alt="icon" className="icons" />
                  </a>
                  <a href="mailto:info@tradeboss.co" aria-label="Email customer care" style={{ textDecoration: "none" }}>
                    <Typography className="sup_cnt_txt" sx={{ paddingBottom: "3px" }}>
                      info@tradeboss.co
                    </Typography>
                  </a>
                </Box>
              </Grid>
            </Grid>

      </Grid>

      {/* MEMBERSHIP BOX */}
      <Grid
        container

        sx={{

          borderRadius: 2,
          mt: 1,
          pb:1,
          pt:1,
          '@media (max-height:620px)': {
            mt: 0,

          }
        }}
      >
        <Grid item xs={12} sm={6}>
          <Typography className="triv_txtd" style={{fontWeight:600}}>{t.NSE}</Typography>
              <Typography className="triv_txtd" style={{ fontWeight: 600 }}>{t.BSE}</Typography>
              <Typography className="triv_txtd" style={{ fontWeight: 600 }}>{t.SEBI}</Typography>
              <Typography className="triv_txtd" style={{ fontWeight: 600 }}>{t.CDSL}</Typography>

        </Grid>
        <Grid item xs={12} sm={6}>
              <Typography className="triv_txtd" style={{ fontWeight: 600 }}>{t.CIN}</Typography>
              <Typography className="triv_txtd" style={{ fontWeight: 600 }}>{t.PAN}</Typography>
              <Typography className="triv_txtd" style={{ fontWeight: 600 }}>{t.GSTIN}</Typography>
        </Grid>
      </Grid>

      {/* Contact Info */}

    </Grid>

    {/* QUERY BOX - Stay beside left column */}
    <Grid
      item
      xs={12}
      md={5}
      className="custom-class"
      sx={{
        display: "flex",
        justifyContent: "center",
      }}
    >
          <Box className="qry_bx" sx={{ padding: errtype == 5 || form.filename ? " 31px 53px 80px 53px " :"34px 53px 5px 53px",
            '@media (max-height:600px)': {
              padding: errtype == 5 || form.filename ? "30px 30px 60px 30px" : "30px",
            },
          }}
          >
            <h2 className="hve_qry">{t.have_query}</h2>

        {/* FORM FIELDS */}


{[
              { label: `${t.form.placeholder.name}`, key: "fname", err: 1 },
              { label: `${t.form.placeholder.contact_no}`, key: "phoneno", err: 2 },
              { label: `${t.form.placeholder.email_id}`, key: "emailid", err: 4 },
              { label: `${t.form.placeholder.query_description}`, key: "description", err:3 },
            ].map(({ label, key, err }) => (
              <Grid2 key={key} sx={{ mb: 2 }}>



                  {/* <InputBase
                    className="emailinputbase"
                    placeholder={label}
                    name={key}
                    value={form[key]}
                    onChange={(e) => handleInputChange(key, e.target.value)}
                    sx={{
                      color: "#000",
                      fontFamily: "Inter400",
                    width: "100%",
                    textAlign: "center", // ✅ Center placeholder & input
                    justifyContent: "center", // Helpful if using flex
                  }}
                  inputProps={{
                    style: {
                      textAlign: "center", // ✅ Ensures placeholder is centered too
                    }
                    }}
                  /> */}
                <InputBase
                  placeholder={label}
                  name={key}
                  type={
                    key === "emailid"
                      ? "email"
                      : key === "phoneno"
                        ? "tel"
                        : "text"
                  }
                  autoComplete={
                    {
                      fname: "name",
                      phoneno: "tel",
                      emailid: "email",
                      description: "off",
                    }[key] || "off"
                  }
                  inputProps={{
                    "aria-label": label,
                    ...(key === "phoneno" && { inputMode: "numeric" }),
                  }}
                  value={form[key]}
                  onChange={(e) => handleInputChange(key, e.target.value)}
                  sx={{
                    width: "100%",
                    color: "#fff",
                    fontFamily: "Inter400",
                    fontSize: "calc(16px + var(--font-delta))",
                    borderBottom: "1px solid rgba(255,255,255,0.4)",
                    paddingBottom: "4px",
                    "&::placeholder": {
                      color: "rgba(255,255,255,0.7)",
                      opacity: 1,
                    },
                    "&:focus-within": {
                      borderBottom: "1px solid #ffffff",
                    },
                  }}
                />

                {errtype === err && (
                  <FormHelperText sx={{ color: "#F74542", ml: "4px",textAlign:"center",fontFamily:"Inter400" }}>
                    {errorMsg}
                  </FormHelperText>
                )}
              </Grid2>
            ))}


        {/* FILE UPLOAD */}
        {/* <Typography className="uploadTitle">

              {t.proof_of_foreign_address}
        </Typography> */}

            <Box sx={{ width: "100%", mb: 3 }}>
              <Box
                component="label"
                htmlFor="support-file-upload"
                sx={{
                  padding: "20px",
                  borderRadius: "8px",
                  border: "2px dashed #999999",
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  "@media (max-height:650px)": {
                    padding: "10px",
                  },
                }}
              >
                <Typography className="drg_drp" sx={{ mr: 1 }}>
                  {t.drag_drop}
                </Typography>

                <Typography component="span" className="brw_file">
                  {t.browse_file}
                </Typography>
              </Box>

              <input
                id="support-file-upload"
                type="file"
                name="file"
                aria-label="Upload supporting document"
                accept=".pdf,.jpg,.jpeg,.png"
                style={{
                  position: "absolute",
                  width: "1px",
                  height: "1px",
                  padding: 0,
                  margin: "-1px",
                  overflow: "hidden",
                  clipPath: "inset(50%)",
                  whiteSpace: "nowrap",
                  border: 0,
                }}
                onChange={(e) => {
                  const file = e.target.files?.[0];

                  if (!file) return;

                  if (file.size > 1024 * 1024) {
                    alert("File size must be less than 1 MB");
                    e.target.value = "";
                    return;
                  }

                  handlePicFile(file);
                }}
              />

              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <img src={Secure} alt="" aria-hidden="true" />

                  <Typography
                    sx={{
                      color: "#7A7C7F",
                      fontSize: "calc(14px + var(--font-delta))",
                      ml: 1,
                    }}
                  >
                    {t.secure}
                  </Typography>
                </Box>
              </Box>
            </Box>

            {errtype === 5 && (
              <p className="errMsgg">{errorMsg}</p>
            )}

            {form.filename && (
              <Typography
                className="successMsg"
              >
                {form.filename}
              </Typography>
            )}

            {successMsg && (
              <Typography
                className="successMsg"
              >
                {successMsg}
              </Typography>
            )}


        <Button fullWidth className="crt_tkt" onClick={Submitquery}>
          {t.create_ticket}
        </Button>
      </Box>
    </Grid>
  </Grid>
</Box>

  );
};

export default SupportWebView;
